// constants
import {SrpCGActionTypes} from './constants';

// types
import {
  IFetch_Srp_Data_Status,
  ISET_SELECTED_HOTEL_ITEM,
  IupdateIsLoadingFirstAPICall,
  IUpdateSRPCGData,
  IUpdateSrpCGDataRequestStatusErrorAction,
} from './types';

// action creators
export function updateIsLoadingFirstAPICall(
  payload: IupdateIsLoadingFirstAPICall['payload'],
): IupdateIsLoadingFirstAPICall {
  return {
    type: SrpCGActionTypes.UPDATE_SRP_API_LOADING,
    payload,
  };
}

export function updateSrpCGDataRequestStatusAction(
  payload: IFetch_Srp_Data_Status['payload'],
): IFetch_Srp_Data_Status {
  return {
    type: SrpCGActionTypes.UPDATE_SEARCH_HOTELS_STATUS,
    payload,
  };
}

export function updateSrpCGDataRequestStatusErrorAction(
  payload: IUpdateSrpCGDataRequestStatusErrorAction['payload'],
) {
  return {
    type: SrpCGActionTypes.UPDATE_SRP_CG_DATA_REQUEST_STATUS_ERROR,
    payload,
  };
}

export function updateSrpCGDataAction(payload: IUpdateSRPCGData['payload']): IUpdateSRPCGData {
  return {
    type: SrpCGActionTypes.UPDATE_SRP_CG_DATA,
    payload,
  };
}

export function setSelectedHotelItemIdAction(
  payload: ISET_SELECTED_HOTEL_ITEM['payload'],
): ISET_SELECTED_HOTEL_ITEM {
  return {
    type: SrpCGActionTypes.SET_SELECTED_HOTEL_ITEM,
    payload,
  };
}

/* ------- SRP Mob Landing API actions ------- */
export const updateSRPCgMobLandingFetchStatus = ({status}: {status: object}) => {
  return {
    type: SrpCGActionTypes.UPDATE_SRP_MOB_LANDING_FETCH_STATUS,
    payload: {
      status,
    },
  };
};

export const updateSRPCgMobLandingData = ({data}: {data: object}) => {
  return {
    type: SrpCGActionTypes.UPDATE_SRP_MOB_LANDING_DATA,
    payload: {
      data,
    },
  };
};

export const updateSRPCgConfig = (payload: Object) => {
  return {
    type: SrpCGActionTypes.UPDATE_SRP_CONFIG,
    payload,
  };
};

export const updateDatelessSeo = (payload: boolean) => {
  return {
    type: SrpCGActionTypes.UPDATE_DATELESS_SEO,
    payload,
  };
};

export const resetCGSRPDataReducerAction = () => {
  return {
    type: SrpCGActionTypes.RESET_CG_SRP_DATA_REDUCER,
    payload: {},
  };
};

export const resetSRPCGReducerAction = () => {
  return {
    type: SrpCGActionTypes.RESET_CG_SRP_REDUCER,
    payload: {},
  };
};

export const resetSRPCGWithFilterResetReducerAction = (payload: any) => {
  return {
    type: SrpCGActionTypes.RESET_CG_SRP_FILTER_RESET_REDUCER,
    payload,
  };
};

/* ------- Similar Hotels API actions ------- */
export const updateSimilarHotels = (payload: any) => {
  return {
    type: SrpCGActionTypes.UPDATE_SIMILAR_HOTELS,
    payload,
  };
};

export const updateSimilarHotelsStatus = (payload: any) => {
  return {
    type: SrpCGActionTypes.UPDATE_SIMILAR_HOTELS_STATUS,
    payload,
  };
};

export const updateSRPFiltersData = (payload: any) => {
  return {
    type: SrpCGActionTypes.UPDATE_FILTER_DATA,
    payload,
  };
};

export const updateFiltersDataStatus = (payload: any) => {
  return {
    type: SrpCGActionTypes.UPDATE_FILTER_DATA_STATUS,
    payload,
  };
};

export const updateCGSrpAPIData = (payload: any) => {
  return {
    type: SrpCGActionTypes.UPDATE_SRP_API_DATA,
    payload,
  };
};
